import Select from "react-select";
import { customStyles } from "../../../../utils/helpers";

interface ReactSelectInputProps {
  name: string;
  options: [];
  getOptionLabel: (option: any) => any;
  getOptionValue: (option: any) => any;
  filterOption?: (option: any, inputValue: string) => any;
  placeholder: string;
  value: string;
  onChange: (val: any, prevVal?: string) => void;
}

const ReactSelectInput = ({
  name,
  options,
  placeholder,
  value,
  getOptionLabel,
  getOptionValue,
  filterOption,
  onChange,
}: ReactSelectInputProps) => {
  return (
    <Select
      name={name}
      options={options}
      placeholder={placeholder}
      value={value}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      filterOption={filterOption}
      className="basic-multi-select"
      classNamePrefix="select"
      styles={customStyles}
      onChange={(e) => onChange(e, value)}
    />
  );
};

export default ReactSelectInput;
